import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/updateRiskRegister', params).then((response) => {
        return response.data;
    });
};
export const useMutationUpdateRiskRegister = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id: number;
    contractId: number;
    name: string;
    description: string;
    status: 'NEW' | 'OPEN' | 'CLOSED';
    probability: 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH' | 'VERY_HIGH';
    distribution: 'UNIFORM' | 'TRIANGLE' | 'BETA_PERT';
    distributionRange: {
        min: number;
        middle: number | null;
        max: number;
    };
    impactType: 'RELATIVE' | 'ABSOLUTE';
    assignee: string;
    segmentRequest?: {
        filter: {
            filters: unknown[];
        };
        segmentId: number | null;
    };
    tags: { name: string }[];
}
